import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5c59c564"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c59c564')) {
      api.createRecord('5c59c564', component.options)
    } else {
      api.reload('5c59c564', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=5c59c564", function () {
      api.rerender('5c59c564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/App.vue"
export default component.exports